"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var phone_pipe_1 = require("../../../shared/pipe/phone.pipe");
var customer_service_1 = require("../../../shared/service/customer.service");
var customer_1 = require("../../../shared/model/customer");
var router_1 = require("@angular/router");
var save_http_error_1 = require("../../../shared/error/save-http-error");
var update_http_error_1 = require("../../../shared/error/update-http-error");
var toast_service_1 = require("../../../shared/service/toast.service");
var CustomerCreateUpdateComponent = /** @class */ (function () {
    function CustomerCreateUpdateComponent(_customerService, _router, _route, _toastService) {
        this._customerService = _customerService;
        this._router = _router;
        this._route = _route;
        this._toastService = _toastService;
        this.editMode = false;
        this.setUpObjects();
        this.editModeVerify();
        this.setPipes();
        this.setUpObservers();
    }
    CustomerCreateUpdateComponent.prototype.ngOnInit = function () {
    };
    CustomerCreateUpdateComponent.prototype.ngAfterViewChecked = function () {
        try {
            Materialize.updateTextFields();
        }
        catch (e) { }
    };
    CustomerCreateUpdateComponent.prototype.save = function () {
        this.handleBooleanFields();
        if (this.editMode) {
            this._customerService.update(this.newCustomer);
        }
        else {
            this._customerService.save(this.newCustomer);
        }
    };
    CustomerCreateUpdateComponent.prototype.editModeVerify = function () {
        var _this = this;
        this.partialTitle = 'Cadastrar ';
        this._route.params.subscribe(function (params) {
            if (params['id']) {
                _this.editMode = true;
                _this.customerId = +params['id'];
                _this._customerService.findById(_this.customerId);
                _this.partialTitle = 'Editar ';
            }
        });
    };
    CustomerCreateUpdateComponent.prototype.checkBagStayAtCustomer = function () {
        this.newCustomer.equipmentBagStayInCustomer = !this.newCustomer.equipmentBagStayInCustomer;
    };
    CustomerCreateUpdateComponent.prototype.checkAwaitingReturn = function () {
        this.newCustomer.equipmentAwaitingReturnOnCustomer = !this.newCustomer.equipmentAwaitingReturnOnCustomer;
    };
    CustomerCreateUpdateComponent.prototype.handleBooleanFields = function () {
        this.newCustomer.equipmentBagStayInCustomer = !!this.newCustomer.equipmentBagStayInCustomer;
        this.newCustomer.equipmentAwaitingReturnOnCustomer = !!this.newCustomer.equipmentAwaitingReturnOnCustomer;
    };
    CustomerCreateUpdateComponent.prototype.setUpObjects = function () {
        this.newCustomer = new customer_1.Customer();
    };
    CustomerCreateUpdateComponent.prototype.setUpObservers = function () {
        if (this.editMode) {
            this.setUpSaveUpdateAction(this._customerService.update$);
        }
        else {
            this.setUpSaveUpdateAction(this._customerService.save$);
        }
        this.setUpFindAction(this._customerService.find$);
        this.setUpErrorAction(this._customerService.error$);
    };
    CustomerCreateUpdateComponent.prototype.setUpSaveUpdateAction = function (observable) {
        var _this = this;
        observable
            .subscribe(function () {
            _this.goBack();
        });
    };
    CustomerCreateUpdateComponent.prototype.setUpFindAction = function (observable) {
        var _this = this;
        observable
            .filter(function (customer) { return customer instanceof customer_1.Customer; })
            .subscribe(function (customer) {
            _this.newCustomer = customer;
        });
    };
    CustomerCreateUpdateComponent.prototype.setUpErrorAction = function (observable) {
        var _this = this;
        observable
            .filter(function (error) { return error instanceof save_http_error_1.SaveHttpError || error instanceof update_http_error_1.UpdateHttpError; })
            .subscribe(function (error) { return _this._toastService.showMessage(error.text, 4000); });
    };
    CustomerCreateUpdateComponent.prototype.setPipes = function () {
        this.phonePipe = new phone_pipe_1.PhonePipe();
    };
    CustomerCreateUpdateComponent.prototype.applyPhoneMask = function (event) {
        return this.phonePipe.transform(event.target.value, event.key);
    };
    CustomerCreateUpdateComponent.prototype.goBack = function () {
        this._router.navigate(['customers/list']);
    };
    CustomerCreateUpdateComponent.ctorParameters = function () { return [{ type: customer_service_1.CustomerService }, { type: router_1.Router }, { type: router_1.ActivatedRoute }, { type: toast_service_1.ToastService }]; };
    return CustomerCreateUpdateComponent;
}());
exports.CustomerCreateUpdateComponent = CustomerCreateUpdateComponent;
//# sourceMappingURL=customer-create-update.component.js.map


// WEBPACK FOOTER //
// customer-create-update.component.js